import * as d3 from "d3";
import {
    contextMenu,
    DEFAULT_AXIS_FONT_SIZE,
    generateDownloadData,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 500,
        margin: { top: 10, right: 250, bottom: 100, left: 150 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    const axisTickFontPx = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var axisfontsize = axisTickFontPx + 'px'
  //  var axislabelfontsize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + 'px'
   // var axislabelfontcolor = chart.axisLabelFontColor
    var axisfontcolor = chart.axisFontColor

    console.log("Chart vizName called:", vizName)

    var renameKeys = function (obj) {
        /*Recursively renames "key" keys to "name" and
            renames "values" keys to "children" */
        obj.name = obj.key
        delete obj.key
        if (obj.values) {
            obj.children = obj.values
            delete obj.values
            obj.children.forEach(renameKeys)
        }
        return obj
    }
    // axios.post(url, filterParam).then(response => {
        let res = resData

        var nest = d3.nest()
            .key(function (d) {
                return d.dim1_name
            })
            .key(function (d) {
                return d.dim2_name
            })
            .key(function (d) {
                return d.dim3_name
            })
            .rollup(function (v) {
                return d3.sum(v, function (d) {
                    return d.metric1
                })
            })
            .entries(res)

    console.log("nest",nest);

        /*The visualization requires there to be a root node*/
        var flareData = {key: chart.y1AxisDisplayName, values: []}
        flareData.values = nest
        renameKeys(flareData);

        (function visualize() {
            var svg = d3.select(divId).select("svg").remove();
            svg = d3.select(divId).append('svg')
                .attr('width', chartWidth + chartMargin.right - chartMargin.left)
                .attr('height', chartHeight + chartMargin.top + chartMargin.bottom)
                .call(responsivefy)
                .append('g')
                .attr('transform', 'translate(' + chartMargin.left + ',' + chartMargin.top + ')')

            var i = 0, duration = 750
            // declares a tree layout and assigns the size

            var treemap = d3.tree().size([chartHeight, chartWidth])
            // Assigns parent, children, height, depth
            let treeData;
            treeData = flareData
            var root = d3.hierarchy(treeData, function (d) {
                return d.children
            })
                .sum(function (d) {
                    return d.value
                })

            root.x0 = chartHeight / 2
            root.y0 = 0

            // Collapse after the second level
            root.children.forEach(collapse)

            update(root)

            // Collapse the node and all it's children
            function collapse(d) {
                if (d.children) {
                    d._children = d.children
                    d._children.forEach(collapse)
                    d.children = null
                }
            }

            function update(source) {
                // Assigns the x and y position for the nodes
                var treeData = treemap(root)

                // Compute the new tree layout.
                var nodes = treeData.descendants(),
                    links = treeData.descendants().slice(1)

                // Normalize for fixed-depth.
                nodes.forEach(function (d) {
                    d.y = d.depth * 180
                })

                // ****************** Nodes section ***************************

                // Update the nodes...
                var node = svg.selectAll('g.node')
                    .data(nodes, function (d) {
                        return d.id || (d.id = ++i)
                    })

                // Enter any new modes at the parent's previous position.
                var nodeEnter = node.enter()
                    .append('g')
                    .attr('class', 'node')
                    .attr('transform', () => {
                        return 'translate(' + source.y0 + ',' + source.x0 + ')'
                    })
                    .on('click', click)
                    .on('contextmenu', function(event, d) {
                        const dimensionKey =
                            d.depth === 1 ? chart.insightNavigator.realDataFieldNames.x1RealDataFieldName :
                                d.depth === 2 ? chart.insightNavigator.realDataFieldNames.y1RealDataFieldName :
                                    chart.insightNavigator.realDataFieldNames.x2RealDataFieldName;
                        // Prepare clickedData with both axes' info
                        const clickedData = {
                            [dimensionKey]: [d.data.name]               // e.g., "metric1"
                        };
                        console.log("clickedData",clickedData);
                        // Generate the menu with current config and filters
                        const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                        // Show the context menu
                        contextMenu(menuItems).call(this, clickedData);

                        // Prevent default context menu
                        event.preventDefault();
                    });

                // Add Circle for the nodes
                nodeEnter.append('circle')
                    .attr('class', 'node')
                    .attr('fill', '#fff')
                    .attr('stroke', 'steelblue')
                    .attr('stroke-width', '5px')
                    .attr('r', 1e-50)
                    .style('fill', (d) => {
                        return d._children ? 'lightsteelblue' : '#fff'
                    })

                // Add labels for the nodes
                nodeEnter.append('text')
                    .attr('dy', '.35em')
                    .attr('x', (d) => {
                        return d.children || d._children ? -13 : 13
                    })
                    .attr('text-anchor', (d) => {
                        return d.children || d._children ? 'end' : 'start'
                    })
                    .text((d) => {
                        return d.data.name + ': ' + numberFormat(d.value)
                    })
                    .style('font-size', axisfontsize)
                    .style('fill', axisfontcolor)

                // UPDATE
                var nodeUpdate = nodeEnter.merge(node)

                // Transition to the proper position for the node
                nodeUpdate.transition()
                    .duration(duration)
                    .attr('transform', function (d) {
                        return 'translate(' + d.y + ',' + d.x + ')'
                    })

                // Update the node attributes and style
                nodeUpdate.select('circle.node')
                    .attr('r', 10)
                    .style('fill', function (d) {
                        return d._children ? 'lightsteelblue' : '#fff'
                    })
                    .attr('cursor', 'pointer')

                // Remove any exiting nodes
                var nodeExit = node.exit().transition()
                    .duration(duration)
                    .attr('transform', function () {
                        return 'translate(' + source.y + ',' + source.x + ')'
                    })
                    .remove()

                // On exit reduce the node circles size to 0
                nodeExit.select('circle').attr('r', 1e-6)

                // On exit reduce the opacity of text labels
                nodeExit.select('text').style('fill-opacity', 1e-6)

                // ****************** links section ***************************

                // Update the links...
                var link = svg.selectAll('path.link')
                    .data(links, function (d) {
                        return d.id
                    })

                // Enter any new links at the parent's previous position.
                var linkEnter = link.enter()
                    .insert('path', 'g')
                    .attr('class', 'link')
                    .attr('d', function () {
                        var o = {x: source.x0, y: source.y0}
                        return diagonal(o, o)
                    })
                    .style('stroke', '#ccc')
                    .style('fill', 'none')
                    .style('stroke-width', '3px')

                // UPDATE
                var linkUpdate = linkEnter.merge(link)

                // Transition back to the parent element position
                linkUpdate.transition()
                    .duration(duration)
                    .attr('d', function (d) {
                        return diagonal(d, d.parent)
                    })

                // Remove any exiting links
                var linkExit = link.exit().transition()
                    .duration(duration)
                    .attr('d', function () {
                        var o = {x: source.x, y: source.y}
                        return diagonal(o, o)
                    })
                    .remove()
                console.warn(linkExit)
                // Store the old positions for transition.
                nodes.forEach(function (d) {
                    d.x0 = d.x
                    d.y0 = d.y
                })

                // Creates a curved (diagonal) path from parent to the child nodes
                function diagonal(s, d) {
                    var path = `M ${s.y} ${s.x}
                          C ${(s.y + d.y) / 2} ${s.x},
                          ${(s.y + d.y) / 2} ${d.x},
                          ${d.y} ${d.x}`

                    return path
                }

                // Toggle children on click.
                function click(d) {
                    if (d.children) {
                        d._children = d.children
                        d.children = null
                    } else {
                        d.children = d._children
                        d._children = null
                    }
                    update(d)
                }
            }
        })(flareData)
    // })
}
